import type { AxiosInstance } from 'axios';
import createSearch from './open/autocomplete.wtf';
import createCollection from './open/collection.wtf';
import createCheck from './open/check.wtf';
import createNFT from './open/nft.wtf';

export const createWTFApi = (http: AxiosInstance) => {
    const nft = createNFT(http);
    const collection = createCollection(http);

    const check = createCheck(http);

    const search = createSearch(http);

    enum QueryWTFApiKey {
        COLLECTIONS_BESTS = 'wtf_collections_bests',
        NFT = 'wtf_nft_get',
        NFT_BY_ADDRESS = 'wtf_nft_by_address',
        NFT_LIST = 'wtf_nft_list',
        COLLECTION = 'wtf_collection',
        COLLECTION_PACK = 'collection_pack',
        COLLECTIONS_LIST_SORT_FILTER = 'wtf_collections_list_sort_filter',
        HEALTH_CHECK = 'wtf_health_check',
        SEARCH_COLLECTIONS = 'wtf_search_collections',
        SEARCH_FILTER_COLLECTIONS = 'wtf_search_filter_collections',
        SEARCH_NFTS = 'wtf_search_nfts',

        HISTORY_TRANSFER = 'wtf_history_transfer',

        NFT_OWNERS = 'wtf_nft_owners',
        NFT_DETAILS = 'wtf_nft_details'
    }

    return {
        collection,
        nft,
        check,
        search,
        QueryWTFApiKey
    } as const;
};

export type WTFApi = ReturnType<typeof createWTFApi>;
